import React from 'react';
import { Link } from 'react-router-dom';
import { useLocalizedPath } from './useLocalizedPath';

/**
 * Drop-in replacement for react-router's <Link> that automatically prepends
 * the active language prefix to absolute internal paths (e.g. /events -> /de/events).
 * External links and hashes are left untouched.
 */
export default function LocalizedLink({ to, children, ...props }) {
  const { localize } = useLocalizedPath();
  return (
    <Link to={localize(to)} {...props}>
      {children}
    </Link>
  );
}
